import { Box, Text } from '../../../ui-kit';
import { editCopyByReplaceString } from '../../../utilities/copyFunctions';
import { Divider } from '../Content/styles';
import SummaryItem from '../SummaryItem';
import SimpleSummaryParkingFeeWarning from './SimpleSummaryParkingFeeWarning';
import * as COPY from './utilities/copy';

const TextWrapperDueToday = ({ children }) => {
  return (
    <Text lineHeight={18} fontSize={0} fontWeight="bold" color="deepLakeBlue.100">
      {children}
    </Text>
  );
};

const TextWrapperDueBeforeParty = ({ children }) => {
  return (
    <Text lineHeight={18} fontSize={0} fontWeight="medium" color="deepLakeBlue.100">
      {children}
    </Text>
  );
};

const SimpleSummaryDue = ({
  dueToday,
  dueBeforeParty,
  remainingBalanceDueDate,
  bookingSummaryParkingFee,
  onPaymentPage
}) => {
  if (!dueToday && !dueBeforeParty) return null;
  return (
    <Box>
      <Divider />
      <SummaryItem
        labelTitle={COPY.DUE_TODAY_SECTION}
        leftColumn={<TextWrapperDueToday>{COPY.PARTY_DUE_TODAY}</TextWrapperDueToday>}
        rightColumn={<TextWrapperDueToday>${dueToday.toFixed(2)}</TextWrapperDueToday>}
      />
      <Text lineHeight={14} fontSize={11} fontWeight="bold" color="deepLakeBlue.100" mb={7}>
        {dueBeforeParty ? COPY.PARTY_72_REFUND_PARTY_DISCLAIMER : COPY.PARTY_NON_REFUND_DISCLAIMER}
      </Text>
      {dueBeforeParty ? (
        <>
          <SummaryItem
            mb={8}
            labelTitle={COPY.DUE_BEFORE_PARTY_SECTION}
            leftColumn={
              <TextWrapperDueBeforeParty>
                {editCopyByReplaceString(COPY.PARTY_DUE_BEFORE_PARTY, remainingBalanceDueDate, '<DATE>')}
              </TextWrapperDueBeforeParty>
            }
            rightColumn={<TextWrapperDueBeforeParty>${dueBeforeParty.toFixed(2)}</TextWrapperDueBeforeParty>}
          />
          <Text lineHeight={14} fontSize={11} fontWeight="bold" color="deepLakeBlue.100" mb={7}>
            {dueBeforeParty ? COPY.PARTY_REFUND_DISCLAIMER : COPY.PARTY_NON_REFUND_DISCLAIMER}
          </Text>
        </>
      ) : null}
      {onPaymentPage && bookingSummaryParkingFee ? (
        <SimpleSummaryParkingFeeWarning bookingSummaryParkingFee={bookingSummaryParkingFee} />
      ) : null}
    </Box>
  );
};

export default SimpleSummaryDue;
